import { createTheme } from '@mui/material/styles';
import { filledInputClasses } from '@mui/material';

// #2d507b
const primary = '#2d507b';
const primaryLight = '#2d507b';
const primaryDark = '#223c5c';

// #f3ca40
const secondary = '#f3ca40';
const secondaryLight = '#f3ca40';
const secondaryDark = '#cfae42';

// #d32f2f
const error = '#d32f2f';
const errorLight = '#ef5350';
const errorDark = '#c62828';

// #05aa05
const success = '#05aa05';
const successLight = '#17d133';
const successDark = '#2e7d32';

const disabled = '#9f9f9f';

export const ThemeFormada = createTheme({
  typography: {
    fontFamily: `Montserrat, Sans-Serif`,
    fontSize: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#000000',
          backgroundColor: secondary,
          width: 'auto',
          boxShadow: '1px 1px 5px grey',
          paddingLeft: '25px',
          paddingRight: '25px',
          borderRadius: '15px',
          '&:disabled': {
            color: '#ffffff',
            backgroundColor: disabled,
            boxShadow: '1px 1px 5px grey',
          },
          ':hover': {
            backgroundColor: secondaryDark,
            boxShadow: '1px 1px 5px grey',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: '12px',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          ':hover': {
            backgroundColor: 'white',
          },
          [`&.${filledInputClasses.focused}`]: {
            backgroundColor: 'white',
          },
        },
        input: {
          ':autofill': {
            borderRadius: 'inherit',
          },
        },
      },
    },
  },
  palette: {
    background: {
      default: primary,
    },
    primary: {
      light: primaryLight,
      main: primary,
      dark: primaryDark,
      contrastText: '#ffffff',
    },
    secondary: {
      light: secondaryLight,
      main: secondary,
      dark: secondaryDark,
      contrastText: '#000000',
    },
    success: {
      light: successLight,
      main: success,
      dark: successDark,
      contrastText: '#ffffff',
    },
    error: {
      light: errorLight,
      main: error,
      dark: errorDark,
      contrastText: '#ffffff',
    },
    rootContainer: {
      color: '#ffffff',
      background: primary,
    },
    button: {
      primary: {
        color: '#000000',
        background: secondary,
        backgroundHover: secondaryDark,
      },
      apple: {
        color: '#000000',
        background: '#ffffff',
        backgroundHover: '#eeeeee',
      },
      confirm: {
        color: '#ffffff',
        background: success,
        backgroundHover: successDark,
      },
      cancel: {
        color: '#ffffff',
        background: error,
        backgroundHover: errorDark,
      },
    },
    menu: {
      color: '#ffffff',
      background: primaryLight,
    },
    progress: {
      circular: {
        primary: primary,
        secondary: secondary,
      },
      linear: {
        primary: secondary,
        secondary: '#ffd7a3',
      },
    },
    infoIcon: primary,
    dialog: {
      title: {
        color: '#ffffff',
        background: primary,
      },
      primaryButton: {
        color: '#000000',
        background: secondary,
        backgroundHover: secondaryDark,
        backgroundDisabled: disabled,
      },
    },
    appBar: {
      top: {
        color: '#ffffff',
        background: primary,
      },
      bottom: {
        color: '#ffffff',
        background: primary,
      },
    },
    textLink: primary,
    card: {
      primary: {
        color: '#ffffff',
        background: primary,
      },
      secondary: {
        color: '#000000',
        background: secondary,
      },
    },
    breadcrumbs: {
      color: '#ffffff',
    },
  },
});
